import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AppContext from "./appContext";
import routes from "./RootRoutes";
import { getAllMenu } from "./services/Menu";

export default function AppProvider({ children }) {
  const [menus, setMenus] = useState([]);
  useEffect(() => {
    const load = async () => {
      try {
        let { data } = await getAllMenu();
        if (data?.length > 0) {
          setMenus(data);
        }
      } catch (error) {
        toast.error("Lấy dữ liệu menu có lỗi");
      }
    };
    load();
  }, []);
  return (
    <AppContext.Provider value={{ menus, routes }}>
      {children}
    </AppContext.Provider>
  );
}
